import { use } from "react";
import { SessionContext } from "./SessionContext";
import type { SessionContextValue } from "./SessionContext";

export function useSession(): SessionContextValue {
  const value = use(SessionContext);
  if (!value) {
    throw new Error("useSession must be used inside <SessionProvider>.");
  }
  return value;
}
